module.exports = __webpack_public_path__ + "media/vue/assets/images/icons/free-shipping-icon-476448d591f6f0e99fc1269420414552.svg";